<template lang="html">

  <form @submit.prevent="validation">

    <h1 v-if="how == 'alumnos'">{{getBrand.logintexts[getLanguage].estudiantes}}</h1>
    <h1 v-if="how == 'antiguos'">{{getBrand.logintexts[getLanguage].antiguos}}</h1>

    <h2 class="title-dato">{{$t('login.iniciar_sesion')}}</h2>

    <div class="login-saml" v-if="!!!getBrand.hideSAML">
      <p v-if="getBrand.ownlogin.textoEgresados[getLanguage]" v-html="getBrand.ownlogin.textoEgresados[getLanguage]"></p>

      <a class="btn -skull-primary" :href="getServer+'/authuniversidades/solicitudAcceso.aspx?portal=alumno'">

        <template v-if="getBrand.ownlogin.botonEgresados && getBrand.ownlogin.botonEgresados[getLanguage]">
          {{getBrand.ownlogin.botonEgresados[getLanguage]}}
        </template>
        <template v-else>
          {{$t('login.acceder_SSO')}}
        </template>

      </a>
    </div>



    <div class="contenedor-input">
      <label :for="`usuario-${how}`">{{$t('login.email')}}</label>
      <input type="text" v-model="data.eUsuario" :id="`usuario-${how}`" :hasContent="!!data.eUsuario">
    </div>

    <div class="contenedor-input" @mouseleave="view.revealPass= false">
      <label :for="`password-${how}`">{{$t('login.contrasena')}}</label>
      <input :type="view.revealPass ? 'text' : 'password'" v-model="data.ePassword" :id="`password-${how}`"
        :hasContent="!!data.ePassword">
      <reveal class="revealPass" :isReveal="view.revealPass" :basic="(mobile) ? false : (how == 'antiguos')"></reveal>
      <i @click="view.revealPass= !view.revealPass" class="revealPass"></i>
      <a class="link lostPass" @click="$emit('revealRecuperar')"
        v-if="getBrand.canRecoveryPass">{{$t('login.contrasena_olvidada')}}</a>
    </div>
    <button class="btn -solid-primary" :loading="view.loading">{{$t('login.acceder')}}</button>

    <router-link v-if="!!getBrand.canRegistroAlumno && getBrand.canRegistroAlumno.some(e => e == how)"
      class="link -white register-link" :to="$t('enlaces.registroalumno')" :style="getStyles.colorTextBlack">
      {{$t('login.aun_no_registrado')}}</router-link>

    <p v-if="getBrand.ownlogin && getBrand.ownlogin.textoAyudaEgresados && getBrand.ownlogin.textoAyudaEgresados[getLanguage]" class="textoayudaEgresados" v-html="getBrand.ownlogin.textoAyudaEgresados[getLanguage]">
    </p>

  </form>
</template>

<script lang="js">


  import { mapActions, mapGetters } from 'vuex';

  import router from '@/router'

  import reveal from '@/components/parts/icons/reveal'

  export default {
    name: 'form-alumno',
    props: ['how'],
    data() {
      return {
        data: {
          eUsuario: '',
          ePassword: '',
          eAmbito: 'PrivadoAlumno'
        },
        view: {
          revealPass: false,
          showLostPass: false,
          loading: false
        },
        mobile: false
      }
    },
    created() {
      this.setIsMobile();
      window.addEventListener('resize', this.setIsMobile)
    },
    components: {
      'reveal': reveal
    },
    methods: {
      validation: function () {
        if (this.canSend) {
          this.view.loading = true;
          this.login(this.data).then(response => {
            (response) ? this.loginOk() : this.view.loading = false;
          });
        }
      },
      loginOk: function () {
        this.view.loading = false
        console.log("routing");
        router.push('/');
      },
      showAlert: function () {
        alert("Redirección a sistemas de universidad/centro para que el usuario recupere su contraseña");
      },
      ...mapActions(['login', 'changeRemember']),
      setIsMobile() {
        this.mobile = (document.documentElement.clientWidth <= 900);
      }
    },
    computed: {
      ...mapGetters([
        'getRememberMe',
        'getStyles',
        'getLogo',
        'basicColors',
        'getServer',
        'getBrand',
        'getLanguage'
      ]),
      canSend: function () {
        var can = (!!this.data.eUsuario && !!this.data.ePassword);
        return can;
      },
      ownstyles: function () {
        return {
          input: {
            'border-bottom': (this.how == 'alumnos') ? `1px solid ${this.basicColors.white}` : `1px solid ${this.basicColors.basic}`
          },
          inputMobile: {
            'border-bottom': `1px solid ${this.basicColors.white}`
          },
          color: {
            color: (this.how == 'alumnos') ? this.basicColors.white : this.basicColors.basic
          },
          colorMobile: {
            color: this.basicColors.white
          }
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  @import '@/assets/css/colors.scss';

  form {
    max-width: 450px;
    padding: 0 15px;
    width: 100%;
  }

  .logo {
    margin-bottom: 40px;
  }

  .contenedor-botones {
    width: 100%;
  }

  .title-dato {
    margin-bottom: 40px;
  }

  .register-link {
    text-align: center;
    width: 100%;
    margin-top: 20px;
    display: inline-block;
  }

  .contenedor-input input {
    border-bottom: 1px solid currentColor;
  }


  .contenedor-input.type-checkbox {
    margin-top: 20px;
  }

  .otro {
    width: 100%;
    text-align: center;
    margin: 15px 0;
  }

  .otro::before {
    content: '';
    width: 40px;
    height: 1px;
    background: currentColor;
    display: inline-block;
    margin-right: 15px;
  }

  .otro::after {
    content: '';
    width: 40px;
    height: 1px;
    background: currentColor;
    display: inline-block;
    margin-left: 15px;
  }

  .btn {
    width: auto;
  }

  .contenedor-botones {
    margin-top: 50px;
  }

  h1 {
    text-align: left;
    width: 100%;
    display: inline-block;
    margin-bottom: 20px;
    text-transform: uppercase;
    font-weight: bold;
  }

  .login-saml{
    margin-bottom: 30px;
  }

  .textoayudaEgresados{
    margin-top: 20px;
  }

  @media screen and (max-width: 920px) {
    form {
      padding: 0;
    }
  }


  @media screen and (max-height: 700px) {

    .title-dato {
      margin-bottom: 20px;
    }

    .contenedor-botones {
      margin-top: 20px;
    }

  }
</style>


// WEBPACK FOOTER //
// src/components/views/login/form-alumno.vue